function prettyDate(date, mini) {
mini = false;

if (!date) return '';

if (typeof (date) == "string") {
date = frappe.datetime.convert_to_user_tz(date);
date = new Date((date || "").replace(/-/g, "/").replace(/[TZ]/g, " ").replace(/\.[0-9]*/, ""));
}

let diff = (((new Date()).getTime() - date.getTime()) / 1000);
let day_diff = Math.floor(diff / 86400);

if (isNaN(day_diff) || day_diff < 0) return '';

// LRM character to keep numbers in correct position in RTL
var LRM = '\u200E';

if (mini) {
if (day_diff == 0) {
if (diff < 60) {
return __("now");
} else if (diff < 3600) {
return __("{0} m", [LRM + Math.floor(diff / 60) + LRM]);
} else if (diff < 86400) {
return __("{0} h", [LRM + Math.floor(diff / 3600) + LRM]);
}
} else {
if (day_diff < 7) {
return __("{0} d", [LRM + day_diff + LRM]);
} else if (day_diff < 31) {
return __("{0} w", [LRM + Math.floor(day_diff / 7) + LRM]);
} else if (day_diff < 365) {
return __("{0} M", [LRM + Math.floor(day_diff / 30) + LRM]);
} else {
return __("{0} y", [LRM + Math.floor(day_diff / 365) + LRM]);
}
}
} else {
if (day_diff == 0) {
if (diff < 60) {
return __("just now");
} else if (diff < 120) {
return __("1 minute ago");
} else if (diff < 3600) {
return __("{0} minutes ago", [LRM + Math.floor(diff / 60) + LRM]);
} else if (diff < 7200) {
return __("1 hour ago");
} else if (diff < 86400) {
return __("{0} hours ago", [LRM + Math.floor(diff / 3600) + LRM]);
}
} else {
if (day_diff == 1) {
return __("yesterday");
} else if (day_diff < 7) {
return __("{0} days ago", [LRM + day_diff + LRM]);
} else if (day_diff < 14) {
return __("1 week ago");
} else if (day_diff < 31) {
return __("{0} weeks ago", [LRM + Math.floor(day_diff / 7) + LRM]);
} else if (day_diff < 62) {
return __("1 month ago");
} else if (day_diff < 365) {
return __("{0} months ago", [LRM + Math.floor(day_diff / 30) + LRM]);
} else if (day_diff < 730) {
return __("1 year ago");
} else {
return __("{0} years ago", [LRM + Math.floor(day_diff / 365) + LRM]);
}
}
}
}

frappe.provide("frappe.datetime");
window.comment_when = function(datetime, mini) {
var timestamp = frappe.datetime.str_to_user ?
frappe.datetime.str_to_user(datetime) : datetime;
return ''
+ prettyDate(datetime, mini) + '';
};
frappe.datetime.comment_when = comment_when;
frappe.datetime.prettyDate = prettyDate;

frappe.datetime.refresh_when = function() {
if (jQuery) {
$(".frappe-timestamp").each(function() {
$(this).html(prettyDate($(this).attr("data-timestamp"), $(this).hasClass("mini")));
});
}
};

setInterval(function() {
frappe.datetime.refresh_when();
}, 60000);
